import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, UpdateShopLocationDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateLocation(
  shop: ShopDto,
  shopLocationId: string,
) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("patch", "/shops/{shopId}/locations/{shopLocationId}");
  const invalidateShop = useInvalidateShop(shop.id);

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (requestBody: UpdateShopLocationDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id, shopLocationId } },
        body: requestBody,
      });
    },
  });
}
